/**
 * Registrazione del service worker.
 *
 * Serve a due cose soltanto: rendere l'app installabile sulla schermata home
 * del tablet e servire l'interfaccia dalla cache quando la rete è lenta. **Non**
 * mette in cache le risposte delle API: PietroChip è uno strumento online, e un
 * elenco di chip vecchio di dieci minuti è peggio di un errore di rete che si
 * vede.
 */
export function registerServiceWorker(): void {
  if (!('serviceWorker' in navigator)) return;

  // In sviluppo un service worker che serve la versione precedente è solo un
  // modo per perdere mezz'ora a capire perché le modifiche non si vedono.
  if (import.meta.env.DEV) return;

  window.addEventListener('load', () => {
    void navigator.serviceWorker.register('/sw.js', { scope: '/' }).catch(() => {
      // Se la registrazione fallisce l'app funziona lo stesso: perde solo
      // l'installabilità, e non è il caso di disturbare l'operatore.
    });
  });
}
